var ww = window.innerWidth || document.documentElement.clientWidth;
var wh = window.innerHeight || document.documentElement.clientHeight;

$(window).on('resize', function() {
    ww = window.innerWidth || document.documentElement.clientWidth;
    wh = window.innerHeight || document.documentElement.clientHeight;
});

function incube_ajax(block,data_type, action, params, success_func, error_func) {
    $.ajax({
        type: "POST",
        url: '/ajax.php?block='+block+'&action='+action+'&data_type='+data_type,
        data: params,
        dataType: data_type,
        success: success_func,
        error: error_func       
    });
}
function incube_file_ajax(block,data_type, action, params, success_func, error_func) {
    $.ajax({
        type: "POST",
        url: '/ajax.php?block='+block+'&action='+action+'&data_type='+data_type,
        data: params,
        dataType: data_type,
        processData: false,
        contentType: false,
        success: success_func,
        error: error_func       
    });
}

$(document).on('submit',".voting_form", function(e){
    e.preventDefault();
    incube_ajax('voting','json', 'send_form', $(this).serializeArray(), votingform);
});
    
function votingform(data){
    if(data.err){
       $('#voting_block_'+data.voting_id+' .answers_cont').append('<div class="voting_err">Выберите ответ</div>'); 
    }else{
       $('#voting_block_'+data.voting_id+' .answers_cont').html(data.html); 
    }
}

function create_map(wrap_id, x, y, text) {
    ymaps.ready(function() {
        var myMap = new ymaps.Map(wrap_id, {
            center: [x, y],
            zoom: 16,
            controls: []
        });
        myMap.behaviors.disable('scrollZoom');
        var myPlacemark = new ymaps.Placemark(myMap.getCenter(), {
            balloonContentBody: [
                '<address>',
                text,
                '</address>'
            ].join('')
        }, {
            preset: 'islands#redDotIcon'
        });
        myMap.geoObjects.add(myPlacemark);
    });
}

$(window).scroll(function() {
    var header_height = $('.page-header').innerHeight() + 10;
    if ($(window).scrollTop() >= header_height) {
        $('.fixed_header').addClass('active');
    } else {
        if ($('.fixed_header').hasClass('active')) {
            $('.sr_box').eq(1).empty().hide();
            $('.search_wrap .search').eq(1).val('');
        }
        $('.fixed_header').removeClass('active');
    }
});



//Функции для работы с cookie.
//Получить значений cookie.
function getCookie(name, json) {
    if (!name) {
        return undefined;
    }

    json = json || false;

    var matches = document.cookie.match(new RegExp(
        "(?:^|; )" + name.replace(/([.$?*|{}()\[\]\\\/+^])/g, '\\$1') + "=([^;]*)"
    ));

    if (matches) {
        var res = decodeURIComponent(matches[1]);
        if (json) {
            try {
                return JSON.parse(res);
            }
            catch(e) {}
        }
        return res;
    }

    return undefined;
}
//Установить значения cookie.
function setCookie(name, value, options) {
    if (!name) {
        return;
    }

    options = options || {path: '/'};

    if (options.expires instanceof Date) {
        options.expires = options.expires.toUTCString();
    }

    if (value instanceof Object) {
        value = JSON.stringify(value);
    }

    var updatedCookie = encodeURIComponent(name) + "=" + encodeURIComponent(value);
    for (var optionKey in options) {
        updatedCookie += "; " + optionKey;

        var optionValue = options[optionKey];

        if (optionValue !== true) {
            updatedCookie += "=" + optionValue;
        }
    }

    document.cookie = updatedCookie;
}
//Удалить cookie.
function deleteCookie(name) {
    setCookie(name, null, {
        expires: new Date(),
        path: '/'
    });
}